import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule, NgFor, DecimalPipe } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { ChartData, ChartOptions } from 'chart.js';
import { EstoqueDashboardService } from '../../services/estoque-dashboard.service';
import { DashboardData } from '../../models/dashboard.model';

@Component({
  selector: 'app-estoque-dashboard',
  standalone: true,
  imports: [CommonModule, BaseChartDirective, NgFor, DecimalPipe],
  templateUrl: './estoque-dashboard.component.html',
  styleUrl: './estoque-dashboard.component.scss'
})
export class EstoqueDashboardComponent implements OnInit {

  dashboardData: DashboardData | null = null;
  carregando = true;
  erro: string | null = null;

  public distribuicaoEstoqueChartData: ChartData<'pie'> = {
    labels: [],
    datasets: [{ data: [], backgroundColor: ['#198754', '#0dcaf0', '#ffc107', '#dc3545'] }]
  };

  public distribuicaoEstoqueChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: 'bottom' } }
  };

  constructor(
    private router: Router,
    private estoqueDashboardService: EstoqueDashboardService
  ) { }

  ngOnInit(): void {
    this.estoqueDashboardService.getDashboardData().subscribe({
      next: (data) => {
        this.dashboardData = data;
        this.atualizarGrafico(data);
        this.carregando = false;
      },
      error: (err) => {
        this.erro = 'Erro ao carregar dados do dashboard. Verifique se a API está acessível.';
        this.carregando = false;
        console.error('Erro ao carregar dashboard:', err);
      }
    });
  }

  private atualizarGrafico(data: DashboardData): void {
    this.distribuicaoEstoqueChartData = {
      labels: data.distribution.map(d => d.status),
      datasets: [{
        data: data.distribution.map(d => d.quantidade),
        backgroundColor: ['#198754', '#0dcaf0', '#ffc107', '#dc3545']
      }]
    };
  }

  goToCadastro() {
    this.router.navigate(['/guardian/cadastro-patrimonio']);
  }
}
